import type { SellerItem } from '~/types/seller';
import { WebSocketsKeys } from '~/types/common';
import type { WebSocketStatus } from '@vueuse/core';

interface IUseStreetMerchant {
  data: Ref<SellerItem[]>;
  statusWS: Ref<WebSocketStatus>;
  isSellerOpen: Ref<boolean>;
}

export default (): IUseStreetMerchant => {
  const { $websockets: websockets } = useNuxtApp();

  const streetMerchantSocket = computed(() => websockets?.[WebSocketsKeys.streetMerchant]);

  const data = computed(() => streetMerchantSocket.value?.parsedData || []);
  const statusWS = computed(() => streetMerchantSocket.value?.status || 'CLOSED');

  const isSellerOpen = computed(() => {
    const socket = streetMerchantSocket.value;
    if (!socket) {
      return false;
    }
    const { parsedData: data } = socket;
    return Boolean(data?.length && data.some((item: SellerItem) => item.amount !== 0));
  });

  return {
    data,
    statusWS,
    isSellerOpen
  };
};
